import ImagePropertiesProvider from './ImagePropertiesProvider';
import ImageOverlayProvider from './ImageOverlayProvider';
import HoverTooltipProvider from './HoverTooltipProvider';
import DocOverlayProvider from './DocOverlayProvider';
import VideoTimestampOverlayProvider from './VideoTimestampOverlayProvider';
import VideoPropertiesProvider from './VideoPropertiesProvider';
import GeneralGroupFilter from './GeneralGroupFilter';
import DefaultColorProvider from './DefaultColorProvider';
import SubProcessTreeProvider from './SubProcessTreeProvider';
import LinkPropertiesProvider from './LinkPropertiesProvider';
import SubProcessFromFileProvider from './SubProcessFromFileProvider';
import WrapInSubProcessProvider from './WrapInSubProcessProvider';
import CollapseToggleContextPadProvider from './CollapseToggleContextPadProvider';
import MultiSelectActionProvider from './MultiSelectActionProvider';
import CustomResizeRules from './CustomResizeRules';
import CustomLabelRenderer from './CustomLabelRenderer';
import LabelAutoSizeBehavior from './LabelAutoSizeBehavior';
import ItSystemRenderer from './ItSystemRenderer';
import BreNavigationProvider from './BreNavigationProvider';
import BreListProvider from './BreListProvider';
import BreContextPadProvider from './BreContextPadProvider';
import LabelWidenBehavior from './LabelWidenBehavior';
import BausteinProvider from './BausteinProvider';
import BausteinNavigationProvider from './BausteinNavigationProvider';
import BausteinContextPadProvider from './BausteinContextPadProvider';

export default {
  __init__: [
    'imagePropertiesProvider', 'imageOverlayProvider', 'docOverlayProvider',
    'videoTimestampOverlayProvider', 'videoPropertiesProvider', 'generalGroupFilter',
    'defaultColorProvider', 'subProcessTreeProvider', 'linkPropertiesProvider',
    'subProcessFromFileProvider', 'wrapInSubProcessProvider', 'collapseToggleContextPadProvider',
    'multiSelectActionProvider', 'customResizeRules', 'customLabelRenderer',
    'labelAutoSizeBehavior', 'itSystemRenderer', 'breNavigationProvider', 'breListProvider',
    'breContextPadProvider', 'labelWidenBehavior', 'bausteinProvider',
    'bausteinNavigationProvider', 'bausteinContextPadProvider'
  ],
  imagePropertiesProvider: ['type', ImagePropertiesProvider],
  imageOverlayProvider: ['type', ImageOverlayProvider],
  docOverlayProvider: ['type', DocOverlayProvider],
  videoTimestampOverlayProvider: ['type', VideoTimestampOverlayProvider],
  videoPropertiesProvider: ['type', VideoPropertiesProvider],
  generalGroupFilter: ['type', GeneralGroupFilter],
  defaultColorProvider: ['type', DefaultColorProvider],
  subProcessTreeProvider: ['type', SubProcessTreeProvider],
  linkPropertiesProvider: ['type', LinkPropertiesProvider],
  subProcessFromFileProvider: ['type', SubProcessFromFileProvider],
  wrapInSubProcessProvider: ['type', WrapInSubProcessProvider],
  collapseToggleContextPadProvider: ['type', CollapseToggleContextPadProvider],
  multiSelectActionProvider: ['type', MultiSelectActionProvider],
  customResizeRules: ['type', CustomResizeRules],
  customLabelRenderer: ['type', CustomLabelRenderer],
  labelAutoSizeBehavior: ['type', LabelAutoSizeBehavior],
  itSystemRenderer: ['type', ItSystemRenderer],
  breNavigationProvider: ['type', BreNavigationProvider],
  breListProvider: ['type', BreListProvider],
  breContextPadProvider: ['type', BreContextPadProvider],
  labelWidenBehavior: ['type', LabelWidenBehavior],
  bausteinProvider: ['type', BausteinProvider],
  bausteinNavigationProvider: ['type', BausteinNavigationProvider],
  bausteinContextPadProvider: ['type', BausteinContextPadProvider],
};

// Viewer-only module: image overlays + hover tooltips + doc badges + video timestamp badges, no properties panel
export const ViewerCustomModule = {
  __init__: [
    'imageOverlayProvider', 'hoverTooltipProvider', 'docOverlayProvider',
    'videoTimestampOverlayProvider', 'itSystemRenderer', 'breNavigationProvider',
    'customLabelRenderer', 'labelWidenBehavior', 'bausteinNavigationProvider',
  ],
  imageOverlayProvider: ['type', ImageOverlayProvider],
  hoverTooltipProvider: ['type', HoverTooltipProvider],
  docOverlayProvider: ['type', DocOverlayProvider],
  videoTimestampOverlayProvider: ['type', VideoTimestampOverlayProvider],
  itSystemRenderer: ['type', ItSystemRenderer],
  breNavigationProvider: ['type', BreNavigationProvider],
  customLabelRenderer: ['type', CustomLabelRenderer],
  labelWidenBehavior: ['type', LabelWidenBehavior],
  // Nur die Navigation, nicht der BausteinProvider: Im Ansichtsmodus wird
  // gelesen, nicht bearbeitet.
  bausteinNavigationProvider: ['type', BausteinNavigationProvider],
};
